import SearchFlowHeader from "../../components/searchFlowHeader/SearchFlowHeader.jsx";
import shellClasses from "../../searchFlow.module.scss";
import GeneralError from "./GeneralError.jsx";

/**
 * Standalone preview of the GeneralError step, reachable at
 * /company/request/generalerror for manual QA — the real flow renders
 * GeneralError as a step inside searchFlow.jsx's shell instead.
 */
const GeneralErrorPreview = () => (
  <div className={`${shellClasses.container} ${shellClasses.routingContainer}`}>
    <SearchFlowHeader hideContinueLater />
    <div className={shellClasses.stepContent}>
      <GeneralError />
    </div>
  </div>
);

export default GeneralErrorPreview;
